import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export function basketOptimizerApi(http: IHttpClient) {
  const url = 'api/v1/basket-optimisation';
  return {
    optimize(body: BasketOptimizerOptimizeRequest) {
      return http
        .postJSON<BasketOptimizerOptimizeResponse>({
          url,
          body,
          targetHost: 'AdvisoryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    cancelOptimize(optimizeId: string) {
      return http.delete({
        url: `api/v1/basket-optimisation/${optimizeId}`,
        targetHost: 'AdvisoryBridge',
      });
    },
  };
}
export interface BasketOptimizerOptimizeRequest {
  listUnderlyingsCodes: string[];
  pinnedUnderlyingsCodes: string[];
  quoteId: string;
  isAstroQuote: boolean;
  productCode: string;
  language: string;
  underlyingsCount: number;
  mutuallyExclusive: boolean;
  targetBasketSize?: number;
  couponFrom?: number;
  couponTo?: number;
}
export interface BasketOptimizerOptimizeResponse {
  requestId: string;
  estimatedComputationTimeInSeconds: number;
}
